import { useEffect, useState, useContext } from 'react';
import SideLogoLayout from './SideLogoLayout';
import CenterLogoLayout from './CenterLogoLayout';
import { AppParamsContext } from 'contexts/AppParamsContext';

export default function TopBarV2() {
  const { appParams } = useContext(AppParamsContext);

  const { elementJustify, elementSize, logoPos, logoSize, text, topBarLogo } = appParams?.navigation?.topBarSettings || {};

  const logoSizeOptions = {
    small: 'h-12 max-w-[250px]',
    normal: 'h-16 max-w-[250px]',
    large: 'h-18 max-w-[250px]',
  };

  const [navElements, setNavElements] = useState([]);
  useEffect(() => {
    if (appParams?.navigation?.topBarElementsV2) {
      setNavElements(
        Object.values(appParams?.navigation?.topBarElementsV2 || {})
          ?.filter((elem) => elem != null)
          ?.sort((a, b) => a?.idx - b?.idx)
      );
    }
  }, [appParams]);

  //if (location.pathname.startsWith("/menu")) return null;

  if (logoPos === 'center')
    return (
      <CenterLogoLayout
        navElements={navElements}
        elementSize={elementSize}
        logoSize={logoSize}
        brandLogo={topBarLogo}
        logoPos={logoPos}
        text={text}
        elementJustify={elementJustify}
        logoSizeOptions={logoSizeOptions}
      />
    );

  if (logoPos == null || logoPos === 'left' || logoPos === 'right' || logoPos === 'hidden')
    return (
      <SideLogoLayout
        navElements={navElements}
        elementSize={elementSize}
        logoSize={logoSize}
        brandLogo={topBarLogo}
        logoPos={logoPos}
        text={text}
        elementJustify={elementJustify}
        logoSizeOptions={logoSizeOptions}
      />
    );

  return <div className={`flex ${elementJustify || 'justify-between'}`}></div>;
}
